import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { acceptInvitationToProject } from "services";
import { resetStateChat } from "store/slicer/GestioneChatSlice";
import { useAppDispatch } from "store/store";

export const CheckProjectShareCodePage = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      searchParams.get("code")?.length &&
      searchParams.get("projectId")?.length
    ) {
      acceptInvitationToProject({
        code: searchParams.get("code")!,
        projectId: searchParams.get("projectId")!,
      })
        .then((_) => {
          dispatch(resetStateChat());
          navigate(`/bo/project?id=${searchParams.get("projectId")!}`);
        })
        .catch((response) => {
          if (response.status === 403 || response.status === 404) {
            navigate("/");
          }
        });
    }
  }, [navigate, searchParams, dispatch]);
  return <></>;
};
